export default __webpack_public_path__ + "static/media/crate-items_v1_2.b497651a.jpg";